<span>
    <div class="page">
        <div class="page-main">
            
            <app-horizontal-menu></app-horizontal-menu>
            
            <div class="router-outlet-wrapper">
                
                <router-outlet></router-outlet>
                
            </div>
        </div>

        <app-footer></app-footer>
        </div>

    <a href="#top" id="back-to-top"><i class="fa fa-long-arrow-up"></i></a>
</span>